/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface MasterPatchAdminUserReqBodyDto
 */
export interface MasterPatchAdminUserReqBodyDto {
    /**
     * 비밀번호
     * @type {string}
     * @memberof MasterPatchAdminUserReqBodyDto
     */
    'password'?: string;
    /**
     * 로그인 제한 여부
     * @type {boolean}
     * @memberof MasterPatchAdminUserReqBodyDto
     */
    'isLoginRestrict'?: boolean;
    /**
     * 어드민 권한들
     * @type {Array<string>}
     * @memberof MasterPatchAdminUserReqBodyDto
     */
    'permissions': Array<MasterPatchAdminUserReqBodyDtoPermissionsEnum>;
}

export const MasterPatchAdminUserReqBodyDtoPermissionsEnum = {
    Dashboard: 'dashboard',
    Report: 'report',
    AccountManagement: 'accountManagement',
    UserManagement: 'userManagement',
    ExchangeManagement: 'exchangeManagement',
    OperationManagement: 'operationManagement'
} as const;

export type MasterPatchAdminUserReqBodyDtoPermissionsEnum = typeof MasterPatchAdminUserReqBodyDtoPermissionsEnum[keyof typeof MasterPatchAdminUserReqBodyDtoPermissionsEnum];


